import { Tab } from './store';
import { getConfig } from '@/common/utilities/settings';

export type TV_DEVICE_ADDON =
    | 'tvboks'
    | 'appletv'
    | 'chromecast'
    | 'chromecast_google_tv'
    | 'none';

export const TV_DEVICE_ADDONS_TO_SHOW: Array<TV_DEVICE_ADDON> = [
    'chromecast',
    'chromecast_google_tv',
    'appletv',
    'none',
];

export const ID_TO_LOGO: { [name: string]: number } = {
    'Stofa Kanalen': 33,
    'Abu Dhabi': 37,
    'Star TV': 39,
    'Haber Turk TV': 89,
    Folketinget: 90,
    'Dream Türk': 91,
    EuroD: 92,
    'Show Turk': 93,
    'BBC Earth': 94,
    'CBS Reality': 95,
    'DR K': 98,
    'DR Ramasjang': 99,
    'Motorsport.tv': 100,
    'Extreme Sports Channel': 102,
    'TV3 SPORT': 103,
    'Animal Planet': 105,
    CNN: 107,
    Boomerang: 112,
    'C More Golf': 116,
    'Hustler TV 24': 117,
    'TV 2 Sport': 119,
    '24Nordjyske': 120,
    DK4: 121,
    'TV 2 Zulu': 122,
    'Kanal 4': 123,
    VH1: 126,
    'Sport Live': 128,
    'Cartoon Network': 129,
    'BBC Brit': 132,
    'BBC World News': 133,
    'Nick Jr.': 138,
    'Discovery World': 139,
    'TV3+': 140,
    'Nat Geo Wild': 141,
    'Discovery Science': 144,
    'TV 2 Fri': 145,
    'MTV 80s': 146,
    'V sport golf': 149,
    'TRT Türk': 150,
    Polonia: 152,
    'National Geographic': 154,
    'Dubai TV': 155,
    'TV 2 News': 156,
    'TRT 1': 157,
    TGRT: 158,
    'The God Channel': 161,
    'Travel Channel': 162,
    HISTORY2: 164,
    DR3: 165,
    'Disney Channel': 166,
    'Disney XD': 167,
    'Viasat Explore': 168,
    'Viasat Nature': 171,
    'HRT TV 1': 173,
    ESC1: 174,
    'RAI UNO': 175,
    'TV5MONDE Europe': 176,
    'TVE Internacional': 177,
    'Deutsche Welle': 178,
    WDR: 181,
    '3Sat': 182,
    'KI.KA': 183,
    MDR: 185,
    'RTL 2': 188,
    'Super RTL': 189,
    VOX: 190,
    'Kabel 1': 191,
    'PRO 7': 192,
    Sat1: 193,
    Viva: 195,
    'SVT1 SydNytt': 197,
    Euronews: 198,
    'Blue Hustler': 199,
    See: 201,
    'Kanal 7 International': 202,
    'TV 2 Charlie': 203,
    Aljazeera: 206,
    'Fashion TV': 207,
    'Discovery Showcase': 208,
    'Nautical Channel': 210,
    'Viasat History': 211,
    'TRT Haber': 212,
    'TV 2 SPORT X': 213,
    'Disney Junior': 216,
    'Canal 9': 219,
    'MTV Club': 223,
    'MTV 90s': 224,
    'MTV Hits': 225,
    'Fine Living Network': 226,
    'MTV Music': 228,
    DR2: 232,
    eSportsTV: 233,
    Mezzo: 241,
    'MTV Live': 244,
    'TV3 PULS': 248,
    'V sport ultra hd': 249,
    'ID - Investigation Discovery': 250,
    'DR Ultra': 251,
    SVT1: 252,
    'Das Erste': 253,
    Arte: 254,
    'Saudi Arabian TV2': 255,
    ZDF: 256,
    'TV3 MAX': 266,
    'Eurosport 1': 268,
    'Eurosport 2': 269,
    "6'eren ": 272,
    Nickelodeon: 273,
    SVT2: 274,
    'TV 2 Norge': 275,
    'Kanal 5': 276,
    'NRK 1': 277,
    DR1: 290,
    MTV: 299,
    'France 24': 306,
    HISTORY: 316,
    TLC: 317,
    'Discovery Channel': 318,
    'TRT 3': 320,
    TNT: 329,
    'hr-fernsehen': 346,
    'SWR Fernsehen BW': 347,
    'Bayerisches FS Süd': 348,
    'Bayerisches FS Nord': 349,
    'rbb Berlin': 350,
    VTV4: 351,
    N24: 352,
    'n-tv': 353,
    'Tele 5': 354,
    'SR Fernsehen': 355,
    'Sonnenklar TV': 356,
    'MBC MAGHREB AL ARABIA': 362,
    'Paramount Network': 363,
    NDR: 364,
    'RTR Planeta': 365,
    'Sky News': 366,
    'Flash TV': 368,
    'RTS Sat': 369,
    'TRT 4-Cocuk': 370,
    'TV4 Sverige': 374,
    RTL: 375,
    TV3: 378,
    'NRK 2': 380,
    Ekstrakanalen: 876,
    'TV 2': 283,
    'TV 2 | Regional': 283,
    'Lokal-tv': 82,
    'C More Film': 99999910,
    'V series & film': 99999911,
};

export const TV_ADDRESS_LOOKUP_TEXTS = {
    header: '1. Tjek din adresse',
    headerVS: '1. Tjek din adresse',
    text: 'Se hvilke tv-kanaler, du kan få på din adresse.',
};

export const FORSENDELSE = 99;
export const OPRETTELSE = 495;

export const TECHNOLOGY_TYPE_DISPLAY_NAMES = {
    none: 'ingenting',
    unknown: 'ukendt',
    coax: 'tv-stikket',
    fiber: 'fiber',
    dsl: 'telefonstikket',
};

export interface HeroBannerTextCollection {
    preheader?: string;
    headline: string;
    postheader?: string;
    lookupText: string;
    checkmarksListItems: string[];
}

export const HEROBANNER_TEXTS: {
    [tab in Tab]: HeroBannerTextCollection;
} = {
    VaelgSelv: {
        headline: 'Bland tv-kanaler og streaming med <strong>VælgSelv</strong>',
        postheader: 'Og skift ud, når du vil',
        lookupText: 'Se hvad du kan få på din adresse:',
        checkmarksListItems: [
            'Tilføj ekstra tv-kanaler og streamingtjenester med Stofa VælgSelv',
        ],
    },
    Packages: {
        preheader: 'Stofa Tv-pakker',
        headline: 'Gode tv-oplevelser pakket til dig',
        lookupText: 'Se hvad du kan få på din adresse:',
        checkmarksListItems: [
            'Stor udvalg af tv-kanaler inkl. Discovery-kanaler',
            'Se tv overalt med Stofa Tv-app',
            'TV 2 Play Favorit + Sport Partner i Stor Tv-pakke',
        ],
    },
};

export const TV_USPS: Record<Tab, string[]> = {
    VaelgSelv: [
        'Skift ud, når du vil',
        'Stort udvalg af streamingtjenester',
        'Live sport i verdensklasse',
    ],
    Packages: [
        'Se tv, hvor du vil',
        'Stort udvalg af streamingtjenester',
        'Live sport i verdensklasse',
    ],
};

// Østjylland
// TV Aarhus
// TV2 Østjylland: 292
